(() => {
  if (customElements.get('ufs-monthly-total')) return;

  class UfsMonthlyTotal extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('[id^="MainProduct-"]');
      this.builder = this.closest('.ufs-addon-picker');
      if (!this.section || !this.builder) return;
      this.variants = JSON.parse(this.querySelector('[data-ufs-plan-prices]').textContent);
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });
      this.section.addEventListener('change', this.update);
      this.section.addEventListener('input', this.update);
      this.section.addEventListener('ufs:base-price-change', this.update);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.section, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-base-cents']
      });
      this.update();
    }

    disconnectedCallback() {
      this.section?.removeEventListener('change', this.update);
      this.section?.removeEventListener('input', this.update);
      this.section?.removeEventListener('ufs:base-price-change', this.update);
      this.observer?.disconnect();
    }

    basePrice() {
      const mixedPlan = this.section.querySelector('.ufs-device-builder');
      if (mixedPlan) return Number(mixedPlan.dataset.baseCents) || 0;
      const picker = this.section.querySelector('variant-selects');
      const selectedOptions = [...(picker?.querySelectorAll('select') || [])].map((select) => select.value);
      const variant = this.variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]))
        || this.variants.find((item) => String(item.id) === this.section.querySelector('input[name="id"]')?.value);
      if (!variant) return 0;
      const selectedPlan = this.section.querySelector('input[name="selling_plan"]:checked')
        || this.section.querySelector('input[name="selling_plan"]');
      const allocation = variant.allocations.find((item) => item.id === selectedPlan?.value)
        || variant.allocations[0];
      return allocation?.price ?? variant.price;
    }

    addonPrice() {
      return [...this.builder.querySelectorAll('[data-ufs-addon]:checked')].reduce((total, checkbox) => {
        const row = checkbox.closest('.ufs-addon-choice');
        const option = row.querySelector('.ufs-addon-variant')?.selectedOptions[0];
        const price = Number(option?.dataset.priceCents ?? checkbox.dataset.priceCents) || 0;
        const quantity = Math.min(50, Math.max(1, Math.floor(Number(row.querySelector('input[type="number"]').value) || 1)));
        return total + price * quantity;
      }, 0);
    }

    write(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    update() {
      const base = this.basePrice();
      const addons = this.addonPrice();
      const formatted = this.formatter.format((base + addons) / 100);
      const monthly = this.dataset.monthlyPrice.replace('__amount__', formatted);
      const accessible = this.dataset.accessiblePrice.replace('__amount__', formatted);
      this.write(this.querySelector('[data-ufs-monthly-total]'), monthly);
      this.write(this.querySelector('[data-ufs-monthly-base]'), this.formatter.format(base / 100));
      this.write(this.querySelector('[data-ufs-monthly-addons]'), this.formatter.format(addons / 100));
      this.section.querySelectorAll('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale, .appstle_subscription_amount, [data-builder-total]')
        .forEach((node) => this.write(node, formatted));
      this.section.querySelectorAll('.appstle_subscription_amount-appstle-sr-only')
        .forEach((node) => this.write(node, accessible));
    }
  }

  customElements.define('ufs-monthly-total', UfsMonthlyTotal);
})();
